import { APIClient } from '../api_helper';
import ExternalAPIClient from '../api_external_helper';
import { api, gbusiness, warehouse_config } from '../../config';
import * as url from '../warehouse/url_helper';

import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_WAREHOUSE_API_URL);
const GBusinessClient = new ExternalAPIClient(api.REACT_APP_GBUSINESS_API_URL);

export const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// PersonalProtectiveEquipments
export const getPersonalProtectiveEquipmentList = params => {
	return apiClient.get(
		`${url.GET_PERSONAL_PROTECTIVE_EQUIPMENT}?${qs.stringify(params, {encodeValuesOnly: true, arrayFormat: "repeat"})}`
	);
};
export const getPersonalProtectiveEquipmentQuery = params => {
	return apiClient.get(
		`${url.GET_PERSONAL_PROTECTIVE_EQUIPMENT_QUERY}?${stringifyParams(
			params,
		)}`,
	);
};
export const getPersonalProtectiveEquipment = personalProtectiveEquipment =>
	apiClient.get(
		url.PERSONAL_PROTECTIVE_EQUIPMENT +
			'/' +
			encodeURIComponent(personalProtectiveEquipment),
	);
export const addNewPersonalProtectiveEquipment = personalProtectiveEquipment =>
	apiClient.post(
		url.ADD_PERSONAL_PROTECTIVE_EQUIPMENT,
		personalProtectiveEquipment,
	);
export const updatePersonalProtectiveEquipment = personalProtectiveEquipment =>
	apiClient.put(
		url.UPDATE_PERSONAL_PROTECTIVE_EQUIPMENT +
			'/' +
			personalProtectiveEquipment._id,
		personalProtectiveEquipment,
	);
export const updatePersonalProtectiveEquipmentDocument = (
	personalProtectiveEquipment
) =>
	apiClient.post(
		url.UPDATE_PERSONAL_PROTECTIVE_EQUIPMENT +
			'/' +
			personalProtectiveEquipment._id +
			'/document/update',
		personalProtectiveEquipment
	);
export const deletePersonalProtectiveEquipment = personalProtectiveEquipment =>
	apiClient.delete(
		url.DELETE_PERSONAL_PROTECTIVE_EQUIPMENT +
			'/' +
			personalProtectiveEquipment._id,
	);
export const setPersonalProtectiveEquipmentCancelled =
	personalProtectiveEquipment =>
		apiClient.post(
			url.PERSONAL_PROTECTIVE_EQUIPMENT_CANCELLED +
				personalProtectiveEquipment,
		);
export const setPersonalProtectiveEquipmentDelivered =
	personalProtectiveEquipment =>
		apiClient.post(
			url.PERSONAL_PROTECTIVE_EQUIPMENT_DELIVERED +
				personalProtectiveEquipment,
		);
export const setPersonalProtectiveEquipmentPicked =
	personalProtectiveEquipment =>
		apiClient.post(
			url.PERSONAL_PROTECTIVE_EQUIPMENT_PICKED,
			personalProtectiveEquipment,
		);

export const getPersonalProtectiveEquipmentStatusList = params => {
	return apiClient.get(
		`${url.PERSONAL_PROTECTIVE_EQUIPMENT_STATUS}?${stringifyParams(params)}`,
	);
};
export const getPersonalProtectiveEquipmentStatusByCode = code =>
	apiClient.get(url.PERSONAL_PROTECTIVE_EQUIPMENT_STATUS_BY_CODE + code);
export const getPersonalProtectiveEquipmentReasonList = params => {
	return apiClient.get(
		`${url.PERSONAL_PROTECTIVE_EQUIPMENT_REASON}?${stringifyParams(params)}`,
	);
};

export const getDashboardStatus = params => {
	return apiClient.get(
		`${url.GET_DASHBOARD_STATUS}?${stringifyParams(params)}`,
	);
};
export const getDashboardReason = params => {
	return apiClient.get(
		`${url.GET_DASHBOARD_REASON}?${stringifyParams(params)}`,
	);
};
export const getDashboardEstablishment = params => {
	return apiClient.get(
		`${url.GET_DASHBOARD_ESTABLISHMENT}?${stringifyParams(params)}`,
	);
};
export const getDashboardCompany = params => {
	return apiClient.get(
		`${url.GET_DASHBOARD_COMPANY}?${stringifyParams(params)}`,
	);
};
export const getAssignedItemsList = params => {
	return apiClient.get(
		`${url.GET_DASHBOARD_ASSIGNED_ITEMS}?${stringifyParams(params)}`,
	);
};

export const getPersonAssignedItemsSummary = params => {
	return apiClient.get(
		`${url.GET_CONTROL_PERSON_ASSIGNED_ITEMS}?${stringifyParams(params)}`,
	);
};
export const getPersonAssignedItemsSummaryQuery = params => {
	return apiClient.get(
		`${url.GET_CONTROL_PERSON_ASSIGNED_ITEMS_QUERY}?${stringifyParams(
			params,
		)}`,
	);
};
export const getPersonAssignedItemsSummaryAll = params => {
	return apiClient.get(
		`${url.GET_CONTROL_PERSON_ASSIGNED_ITEMS_ALL}?${stringifyParams(params)}`,
	);
};
export const getPersonAssignmentsQuery = params => {
	return apiClient.get(
		`${url.GET_PERSON_ASSIGNMENTS_QUERY}?${stringifyParams(params)}`,
	);
};
export const getPersonAssignmentItemsQuery = params => {
	return apiClient.get(
		`${url.GET_PERSON_ASSIGNMENTS_ITEMS_QUERY}?${stringifyParams(params)}`,
	);
};
export const getWarehouseAssignedItemsSummary = params => {
	return apiClient.get(
		`${url.GET_CONTROL_WAREHOUSE_ASSIGNED_ITEMS}?${stringifyParams(params)}`,
	);
};
export const getWarehouseAssignedItemsSummaryQuery = params => {
	return apiClient.get(
		`${url.GET_CONTROL_WAREHOUSE_ASSIGNED_ITEMS_QUERY}?${stringifyParams(
			params,
		)}`,
	);
};

// Warehouses
export const getWarehouseList = params => {
	return apiClient.get(`${url.GET_WAREHOUSES}?${stringifyParams(params)}`);
};

const normalizeWarehouseListPayload = payload => {
	if (Array.isArray(payload)) return payload;
	if (payload?.data && Array.isArray(payload.data)) return payload.data;
	return [];
};

/** D-008: válida para ingreso RESPEL si `respel` y uso tipo RESPEL. */
export const isWarehouseEligibleForRespelIntake = warehouse => {
	if (!warehouse || warehouse.respel !== true) return false;
	const usageType = warehouse.warehouse_usage_type;
	if (
		usageType &&
		typeof usageType === 'object' &&
		usageType.code === 'RESPEL'
	) {
		return true;
	}
	const configuredId =
		warehouse_config.REACT_APP_WAREHOUSE_USAGE_TYPE_RESPEL_ID;
	if (configuredId && warehouse.warehouse_usage_type_id === configuredId) {
		return true;
	}
	return false;
};

/**
 * Lista de bodegas para selectores RESPEL. El backend ignora `respel=true` en GET /warehouse/;
 * se filtra en cliente y (si existe env) por `warehouse_usage_type_id` como en flujos EPP.
 * @param {string|null|undefined} establishmentId - Si se indica, limita a bodegas de ese establecimiento.
 */
export const getRespelWarehouseList = async establishmentId => {
	const params = { populate: ['warehouse_usage_type'] };
	const respelUsageTypeId =
		warehouse_config.REACT_APP_WAREHOUSE_USAGE_TYPE_RESPEL_ID;
	if (respelUsageTypeId) {
		params.warehouse_usage_type_id = respelUsageTypeId;
	}
	if (establishmentId) {
		params.establishment_id = establishmentId;
	}
	const raw = await getWarehouseList(params);
	let list = normalizeWarehouseListPayload(raw).filter(
		isWarehouseEligibleForRespelIntake,
	);
	if (establishmentId) {
		const est = String(establishmentId);
		list = list.filter(
			w =>
				String(w.establishment_id || w.establishment?._id || '') === est,
		);
	}
	return list;
};

/** D-027: válida para recepción NP si usage RESIDUOS_NP y no está marcada RESPEL. */
export const isWarehouseEligibleForResiduosNp = warehouse => {
	if (!warehouse || warehouse.respel === true) return false;
	const usageType = warehouse.warehouse_usage_type;
	if (
		usageType &&
		typeof usageType === 'object' &&
		usageType.code === 'RESIDUOS_NP'
	) {
		return true;
	}
	const configuredId =
		warehouse_config.REACT_APP_WAREHOUSE_USAGE_TYPE_RESIDUOS_NP_ID;
	if (configuredId && warehouse.warehouse_usage_type_id === configuredId) {
		return true;
	}
	return false;
};

/**
 * Bodegas transitorias para guías no peligrosas (usage RESIDUOS_NP, respel !== true).
 * @param {string|null|undefined} establishmentId
 */
export const getNonHazardousTransitoryWarehouseList = async establishmentId => {
	const params = { populate: ['warehouse_usage_type'] };
	const npUsageTypeId =
		warehouse_config.REACT_APP_WAREHOUSE_USAGE_TYPE_RESIDUOS_NP_ID;
	if (npUsageTypeId) {
		params.warehouse_usage_type_id = npUsageTypeId;
	}
	if (establishmentId) {
		params.establishment_id = establishmentId;
	}
	const raw = await getWarehouseList(params);
	let list = normalizeWarehouseListPayload(raw).filter(
		isWarehouseEligibleForResiduosNp,
	);
	if (establishmentId) {
		const est = String(establishmentId);
		list = list.filter(
			w =>
				String(w.establishment_id || w.establishment?._id || '') === est,
		);
	}
	return list;
};

// Warehouses con populate (para diccionario global)
export const getWarehouseListWithEstablishment = params => {
	const queryParams = {
		...params,
		populate: params.populate || ['establishment'],
		pagination: params.pagination || { page: 1, pageSize: 1000 },
	};
	return apiClient.get(
		`${url.GET_WAREHOUSES}?${stringifyParams(queryParams)}`,
	);
};
export const getWarehouse = warehouse =>
	apiClient.get(url.WAREHOUSE + '/' + encodeURIComponent(warehouse));
export const getWarehouseByEstablishment = establishment_id =>
	apiClient.get(
		url.WAREHOUSE_BY_ESTABLISHMENT +
			'/' +
			encodeURIComponent(establishment_id),
	);
export const addNewWarehouse = warehouse =>
	apiClient.post(url.ADD_WAREHOUSE, warehouse);
export const updateWarehouse = warehouse =>
	apiClient.put(url.UPDATE_WAREHOUSE + '/' + warehouse._id, warehouse);
export const deleteWarehouse = warehouse =>
	apiClient.delete(url.DELETE_WAREHOUSE + '/' + warehouse._id);

export const synchronizeWarehouse = warehouse =>
	apiClient.post(url.SYNCHRONIZE_WAREHOUSE, warehouse);
export const synchronizeWarehouseItems = (warehouse_id, group_code) =>
	apiClient.post(
		`warehouse/synchronize/${warehouse_id}/item/group/${group_code}`,
	);
export const synchronizeWarehouseGroup = () =>
	apiClient.post(`warehouse/group/synchronize`);
export const getWarehouseGroupExist = (establishment_id, group_code) =>
	apiClient.post(
		`warehouse/exists/establishment/${establishment_id}/item/group/${group_code}`,
	);

// Warehouse Transfer
export const getWarehouseTransferList = params => {
	return apiClient.get(
		`${url.GET_WAREHOUSE_TRANSFERS}?${stringifyParams(params)}`,
	);
};
export const getWarehouseTransfer = warehouseTransfer =>
	apiClient.get(
		url.WAREHOUSE_TRANSFER + '/' + encodeURIComponent(warehouseTransfer),
	);
export const addNewWarehouseTransfer = warehouseTransfer =>
	apiClient.post(url.ADD_WAREHOUSE_TRANSFER, warehouseTransfer);
export const updateWarehouseTransfer = warehouseTransfer =>
	apiClient.put(
		url.UPDATE_WAREHOUSE_TRANSFER + '/' + warehouseTransfer._id,
		warehouseTransfer,
	);
export const deleteWarehouseTransfer = warehouseTransfer =>
	apiClient.delete(
		url.DELETE_WAREHOUSE_TRANSFER + '/' + warehouseTransfer._id,
	);

// Item Group
export const getItemGroupList = params => {
	return apiClient.get(
		`${url.GET_ITEM_GROUPS}?${stringifyParams(params)}`,
	);
};
export const getItemGroupQuery = params => {
	return apiClient.get(
		`${url.GET_ITEM_GROUPS_QUERY}?${stringifyParams(params)}`,
	);
};
export const getItemGroup = item_group =>
	apiClient.get(url.ITEM_GROUP + '/' + encodeURIComponent(item_group));
export const addNewItemGroup = item_group =>
	apiClient.post(url.ADD_ITEM_GROUP, item_group);
export const updateItemGroup = item_group =>
	apiClient.put(
		url.UPDATE_ITEM_GROUP + '/' + item_group._id,
		item_group,
	);
export const deleteItemGroup = item_group =>
	apiClient.delete(url.DELETE_ITEM_GROUP + '/' + item_group._id);
// Warehouses Item
export const getWarehouseItemList = params => {
	return apiClient.get(
		`${url.GET_WAREHOUSE_ITEMS}?${stringifyParams(params)}`,
	);
};
export const getWarehouseItemQuery = params => {
	return apiClient.get(
		`${url.GET_WAREHOUSE_ITEMS_QUERY}?${stringifyParams(params)}`,
	);
};
export const getWarehouseItem = warehouse_item =>
	apiClient.get(url.WAREHOUSE_ITEM + '/' + encodeURIComponent(warehouse_item));
export const addNewWarehouseItem = warehouse_item =>
	apiClient.post(url.ADD_WAREHOUSE_ITEM, warehouse_item);
export const updateWarehouseItem = warehouse_item =>
	apiClient.put(
		url.UPDATE_WAREHOUSE_ITEM + '/' + warehouse_item._id,
		warehouse_item,
	);
export const deleteWarehouseItem = warehouse_item =>
	apiClient.delete(url.DELETE_WAREHOUSE_ITEM + '/' + warehouse_item._id);
export const checkWarehouseItemExists = name =>
	apiClient.get(url.CHECK_WAREHOUSE_ITEM_EXISTS + '?name=' + name);

export const reserveWarehouseItem = warehouse_item =>
	apiClient.get(
		url.WAREHOUSE_ITEM_RESERVE +
			'?warehouse_item_id=' +
			warehouse_item.warehouse_item_id +
			'&quantity=' +
			warehouse_item.quantity,
	);
export const releaseWarehouseItem = warehouse_item =>
	apiClient.get(
		url.WAREHOUSE_ITEM_RELEASE +
			'?warehouse_item_id=' +
			warehouse_item.warehouse_item_id +
			'&quantity=' +
			warehouse_item.quantity,
	);
export const transferWarehouseItem = warehouse_item =>
	apiClient.post(url.TRANSFER_WAREHOUSE_ITEM, warehouse_item);
export const deliverWarehouseItem = warehouse_item =>
	apiClient.post(url.WAREHOUSE_ITEM_DELIVER, warehouse_item);
export const returnWarehouseItem = warehouse_item =>
	apiClient.post(url.WAREHOUSE_ITEM_RETURN, warehouse_item);
export const pickWarehouseItem = warehouse_item =>
	apiClient.post(url.WAREHOUSE_ITEM_DELIVER, warehouse_item);
export const receiveWarehouseItem = warehouse_item =>
	apiClient.post(url.WAREHOUSE_ITEM_RECEIVE, warehouse_item);
export const deliverWarehouseItemStockCheck = warehouse_item =>
	apiClient.post(url.WAREHOUSE_ITEM_DELIVER_STOCK_CHECK, warehouse_item);

// Warehouse Item Transfer
export const getWarehouseItemTransferList = params => {
	return apiClient.get(
		`${url.GET_WAREHOUSE_ITEM_TRANSFERS}?${stringifyParams(params)}`,
	);
};
export const getWarehouseItemTransfer = WAREHOUSE_ITEM_TRANSFER =>
	apiClient.get(
		url.WAREHOUSE_ITEM_TRANSFER +
			'/' +
			encodeURIComponent(WAREHOUSE_ITEM_TRANSFER),
	);
export const addNewWarehouseItemTransfer = WAREHOUSE_ITEM_TRANSFER =>
	apiClient.post(url.ADD_WAREHOUSE_ITEM_TRANSFER, WAREHOUSE_ITEM_TRANSFER);
export const updateWarehouseItemTransfer = WAREHOUSE_ITEM_TRANSFER =>
	apiClient.put(
		url.UPDATE_WAREHOUSE_ITEM_TRANSFER + '/' + WAREHOUSE_ITEM_TRANSFER._id,
		WAREHOUSE_ITEM_TRANSFER,
	);
export const deleteWarehouseItemTransfer = WAREHOUSE_ITEM_TRANSFER =>
	apiClient.delete(
		url.DELETE_WAREHOUSE_ITEM_TRANSFER + '/' + WAREHOUSE_ITEM_TRANSFER._id,
	);
export const transferWarehouseItemTransfer = WAREHOUSE_ITEM_TRANSFER =>
	apiClient.post(
		url.TRANSFER_WAREHOUSE_ITEM_TRANSFER,
		WAREHOUSE_ITEM_TRANSFER,
	);
export const warehouseItemTransferReception =
	WAREHOUSE_ITEM_TRANSFER_RECEPTION =>
		apiClient.post(
			url.TRANSFER_WAREHOUSE_ITEM_TRANSFER_RECEPTION,
			WAREHOUSE_ITEM_TRANSFER_RECEPTION,
		);
export const getWarehouseItemTransferListQuery = params => {
	return apiClient.get(
		`${url.GET_WAREHOUSE_ITEM_TRANSFER_QUERY}?${stringifyParams(params)}`,
	);
};

// Warehouses Category
export const getWarehouseCategoryList = params => {
	return apiClient.get(
		`${url.GET_WAREHOUSE_CATEGORIES}?${stringifyParams(params)}`,
	);
};
export const getWarehouseCategory = warehouse_category =>
	apiClient.get(
		url.WAREHOUSE_CATEGORY + '/' + encodeURIComponent(warehouse_category),
	);
export const addNewWarehouseCategory = warehouse_category =>
	apiClient.post(url.ADD_WAREHOUSE_CATEGORY, warehouse_category);
export const updateWarehouseCategory = warehouse_category =>
	apiClient.put(
		url.UPDATE_WAREHOUSE_CATEGORY + '/' + warehouse_category._id,
		warehouse_category,
	);
export const deleteWarehouseCategory = warehouse_category =>
	apiClient.delete(
		url.DELETE_WAREHOUSE_CATEGORY + '/' + warehouse_category._id,
	);
export const checkWarehouseCategoryExists = name =>
	apiClient.get(url.CHECK_WAREHOUSE_CATEGORY_EXISTS + '?name=' + name);

// Warehouses Group
export const getWarehouseGroupList = params => {
	return apiClient.get(
		`${url.GET_WAREHOUSE_GROUP}?${stringifyParams(params)}`,
	);
};
export const getWarehouseGroup = warehouse_group =>
	apiClient.get(
		url.WAREHOUSE_GROUP + '/' + encodeURIComponent(warehouse_group),
	);
export const addNewWarehouseGroup = warehouse_group =>
	apiClient.post(url.ADD_WAREHOUSE_GROUP, warehouse_group);
export const updateWarehouseGroup = warehouse_group =>
	apiClient.put(
		url.UPDATE_WAREHOUSE_GROUP + '/' + warehouse_group._id,
		warehouse_group,
	);
export const deleteWarehouseGroup = warehouse_group =>
	apiClient.delete(url.DELETE_WAREHOUSE_GROUP + '/' + warehouse_group._id);
export const checkWarehouseGroupExists = name =>
	apiClient.get(url.CHECK_WAREHOUSE_GROUP_EXISTS + '?name=' + name);

// Warehouses Type
export const getWarehouseTypeList = params => {
	return apiClient.get(`${url.GET_WAREHOUSE_TYPE}?${stringifyParams(params)}`);
};
export const getWarehouseType = warehouse_type =>
	apiClient.get(url.WAREHOUSE_TYPE + '/' + encodeURIComponent(warehouse_type));
export const addNewWarehouseType = warehouse_type =>
	apiClient.post(url.ADD_WAREHOUSE_TYPE, warehouse_type);
export const updateWarehouseType = warehouse_type =>
	apiClient.put(
		url.UPDATE_WAREHOUSE_TYPE + '/' + warehouse_type._id,
		warehouse_type,
	);
export const deleteWarehouseType = warehouse_type =>
	apiClient.delete(url.DELETE_WAREHOUSE_TYPE + '/' + warehouse_type._id);

// GBusiness
let authToken = null;

export const authenticate = async credentials => {
	// Autenticar solo si el token no ha sido obtenido previamente
	try {
		if (!authToken) {
			const response = await GBusinessClient.authenticate(
				credentials.username,
				credentials.password,
			);
			authToken = response;
			return authToken;
		}
	} catch (error) {
		console.error('Error durante la autenticación:', error.message);
		throw error;
	}
};
// DTE
export const createDTE = async (dte, service) => {
	try {
		const authData = {
			username: gbusiness.USER,
			password: gbusiness.PASS,
		};

		await authenticate(authData);
		const query = service ? `?${stringifyParams({ service })}` : '';
		return await GBusinessClient.post(`${url.CREATE_DTE}${query}`, dte, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al crear el DTE:', error.message);
		throw error;
	}
};
export const readDTEFacele = async ({ file_type, dte_id }) => {
	try {
		const authData = {
			username: gbusiness.USER,
			password: gbusiness.PASS,
		};

		await authenticate(authData);
		return await GBusinessClient.get(
			`${url.READ_DTE_FACELE}/${encodeURIComponent(
				file_type,
			)}/${encodeURIComponent(dte_id)}`,
			{
				headers: { Authorization: `Bearer ${authToken}` },
				responseType: 'blob',
			},
		);
	} catch (error) {
		console.error('Error al leer el DTE:', error.message);
		throw error;
	}
};

// Position
export const getPositionList = params => {
	return apiClient.get(`${url.GET_POSITION}?${stringifyParams(params)}`);
};
export const getPosition = position =>
	apiClient.get(url.POSITION + '/' + encodeURIComponent(position));
export const addNewPosition = position =>
	apiClient.post(url.ADD_POSITION, position);
export const updatePosition = position =>
	apiClient.put(url.UPDATE_POSITION + '/' + position._id, position);
export const deletePosition = position =>
	apiClient.delete(url.DELETE_POSITION + '/' + position._id);

// Dashboard
export const getCostPPEByEstablishment = params => {
	return apiClient.get(
		`${url.GET_COST_PPE_BY_ESTABLISHMENT}?${stringifyParams(params)}`,
	);
};
